export const META_TYPE = 'serviceOverview';
export const META_VER = 'v1';

export const CMD_SERVICEOVERVIEW_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
